import { helpers } from '../helpers.js';

var search = {
	selectors: { },

	init: function () {
		var self = this;

		self.search();
		self.onSearch();
	},

	onSearch: function() {
		var self = this;

		jQuery( '.header-search__form > input[type="text"]' ).on( 'keyup', function(){
			const searchPlace 	= jQuery( this ).closest( '.header-search' );
			const value 		= jQuery( this ).val();

			if( value.length < 3 ) {
				return false;
			}

			helpers.pctApiCall({
				action: 'get_search_data',
				query: value,
			}).then( response => {
				if( ! response.success ) {
					console.error( 'Error: ', response.data.message ); 
					return false;
				}
	
				searchPlace.find( '.js-searcher' ).removeClass( 'd-none' );
				searchPlace.find( '.js-searcher ul' ).html( response.data.html );
				
				if( response.data.hide_more ) {
					searchPlace.find( '.header-search__searched__more' ).addClass( 'd-none' );
				}

				if( ! response.data.hide_more ) {
					searchPlace.find( '.header-search__searched__more' ).removeClass( 'd-none' );
				}
	
			}).catch(error => {
				console.error( 'Error: ', error); 
			});
		});

		jQuery( '.header-search__form > input[type="text"]' ).on( 'keyup', function( event ) {
			if ( event.key === 'Enter') {
				event.preventDefault();
				self.directSearch( jQuery( this ) );	
			}
		});

		jQuery( '.header-search__searched__more' ).on( 'click', function( event ) {
			event.preventDefault();
			self.directSearch( jQuery( this ) );
		});
	},

		directSearch: function( element ) {
			const searchPlace 	= jQuery( element ).closest( '.header-search' );
			const value 		= searchPlace.find( '.header-search__form > input[type="text"]' ).val();
			const moreLink 		= searchPlace.find( '.header-search__searched__more' ).attr( 'href' );

			window.location.href = moreLink + value;
		},

	search: function() {
		if( ! document.querySelector( 'a.search' ) ) {
			return false;
		}

		const fixedSearch = jQuery( '.header-search:not( .header-search--inline )' );

		jQuery( 'a.search' ).on( 'click', function( e ) {
			e.preventDefault();
			fixedSearch.removeClass( 'd-none' );
		});

		/* document.querySelector( 'a.search' ).addEventListener("click", (e) => {
			e.preventDefault();
			document.querySelector( '.header-search' ).classList.remove( 'd-none' );
		}); */

		jQuery( '.header-search:not( .header-search--inline ) button.header-search__close' ).on( 'click', function( e ) {
			fixedSearch.addClass( 'd-none' );
		});
		
		/* document.querySelector( 'button.header-search__close' ).addEventListener("click", (e) => {
			document.querySelector( '.header-search' ).classList.add( 'd-none' );
		}); */

		jQuery( '.header-search__clear' ).on( 'click', function( e ) {
			jQuery( this ).parent().find( 'input[type="text"]' ).val( '' );
		});
		
		/* document.querySelector( '.header-search__clear' ).addEventListener("click", (e) => {
			e.target.closest( '.header-search__form > input[type="text"]' ).value = '';
		}); */
	},
};

export { search };